<template>
  <input
    v-model="email"
    type="email"
    placeholder="e.x. john.doe@gmail.com"
    :class="context.classes.input"
    @input="handleInput"
  >
</template>

<script setup>
import { ref } from 'vue';
import { api } from '~/src/api';
import { delay } from '~/src/util';


const props = defineProps ({
  context: Object
});

if (typeof props.context.help === 'undefined') {
  props.context.label = 'Email Address';
}

if (typeof props.context.help === 'undefined') {
  props.context.help  = 'Your email is what you use to login to your DataSeal dashboard. An email may only be registered once with DataSeal.';
}

let email = ref (props.context.value || '');

function handleInput () {
  delay ('validation', async () => {
    try {
      await api.post ('/validate/email', {
        email: email.value
      });

      props.context.node.input (email.value);
      props.context.node.setErrors ([]);
    } catch (e) {
      props.context.node.setErrors (null, { email: e.response.data.error, primaryEmail: e.response.data.error });
    }
  }, 750);
}
</script>